import { Grain } from '../sim/snowpack.ts';

/**
 * Consistent grain-class colour palette for the snow-profile view (and its legend). Arbitrary but
 * distinguishable — not a standard (SNOWPACK/niViz use grain-specific symbols, not just colour).
 */
export const GRAIN_COLORS: Record<Grain, string> = {
  [Grain.PP]: '#dbe9ff',
  [Grain.DF]: '#a9c6e8',
  [Grain.RG]: '#6f9bc9',
  [Grain.RGwp]: '#d9a441',
  [Grain.FC]: '#e0a24d',
  [Grain.DH]: '#a8672a',
  [Grain.SH]: '#c65bd1',
  [Grain.PPgp]: '#4fae4f',
  [Grain.MF]: '#3fa6a6',
  [Grain.IF]: '#8a8f99',
  [Grain.Debris]: '#b07a4a',
};
